var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-import.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00002 10.5L9.33335 7.58329H7.58335V1.16663H6.41669V7.58329H4.66669L7.00002 10.5Z",
    fill: "#00B45E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0278 3H8.58333V4.53846H11.0278V11.4615H2.47222V4.53846H4.91667V3H2.47222C1.79817 3 1.25 3.69 1.25 4.53846V11.4615C1.25 12.31 1.79817 13 2.47222 13H11.0278C11.7018 13 12.25 12.31 12.25 11.4615V4.53846C12.25 3.69 11.7018 3 11.0278 3Z",
    fill: "#00B45E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxImport);
export default __webpack_public_path__ + "static/media/bx-import.824f5f4d2d07d5c6054f2348f4c67b21.svg";
export { ForwardRef as ReactComponent };